import {
  getReq,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import router from '@/router'
import * as Utils from '@/utils'
import * as Lodash from 'lodash'

// const

const state = {
  compUserDDList: [],
  subsysDDList: [
    // { subsysKey: 'PROFILE', subsysType: 'PROFILE', subsysName: '个人信息', status: 'A' },
    { subsysKey: 'SYS', subsysType: 'SYS', subsysName: '系统', status: 'A', frontendType: 'CORP' },
    { subsysKey: 'COMP', subsysType: 'COMP', subsysName: '公司数据', status: 'A', frontendType: 'CORP' },
    { subsysKey: 'PROJ', subsysType: 'BIZ', subsysName: '项目版', status: 'A', frontendType: 'PROJ' },
    { subsysKey: 'CORP', subsysType: 'BIZ', subsysName: '公司版', status: 'A', frontendType: 'CORP' }
  ],
  SYSTEM_SIDER: {
    PROJ: { // subsysKey
      path: '/subsys_proj',
      title: '项目财务数据板块',
      header: 'home',
      // icon: 'md-speedometer',
      children: [
        {
          path: '/subsys_proj/conf',
          title: '配置',
          moduleType: 'CONF',
          children: [
            {
              path: '/proj/projuser',
              title: '项目财务用户权限'
            },
            {
              path: '/proj/ctracct',
              title: '核算主体管理'
            },
            {
              path: '/proj/project',
              title: '项目管理'
            },
            {
              path: '/proj/comprpt/compIncomeStatement',
              title: '损益表'
            },
            {
              path: '/proj/comprpt/compAssetDebt',
              title: '资产负债表'
            },
            {
              path: '/proj/comprpt/compAcctReceive',
              title: '应收统计表'
            },
            {
              path: '/proj/comprpt/compAcctPay',
              title: '应付统计表'
            },
            {
              path: '/proj/conf/pdTypeLevelOne',
              title: '成控品名一级分类'
            },
            {
              path: '/proj/conf/pdName',
              title: '成控品名'
            },
            {
              path: '/proj/conf/pdInquiry',
              title: '成控品名询价'
            }
          ]
        },
        {
          path: '/subsys_proj/data',
          title: '项目',
          moduleType: 'DATA',
          children: []
        }
      ]
    },
    SYS: { // subsysKey
      path: '/subsys_sys',
      title: '系统板块',
      header: 'home',
      // icon: 'md-speedometer',
      children: [
        {
          path: '/subsys_sys/data',
          title: '数据',
          moduleType: 'DATA',
          children: [
            {
              path: '/api/audit/actiontrail',
              title: '历史事件'
            }
          ]
        }
      ]
    }
  },
  currentMenuSider: [],
  // authedModuleKeyList: ['MTUJDI'],
  authedSubsysKeyList: [],
  authedModuleKeyList: [],
  authedFnKeyList: [],
  authedFnKeyMap: {},
  // currentProjId: ''
  currentSubsysKey: '',
  currentSubsysList: [],
  currentModuleType: '',
  END_STATE: null
}

const getters = {}

const actions = {
  async findCompUserDDList({
    commit,
    state
  }, { compId, codeParam }) {
    // debugger
    const responseData = await getReq(END_POINTS.FIND_SYS_COMP_USER_DD_LIST + `?compId=${compId}`, { headerCodeMap: await getHeaderCodeMap(codeParam) })
    if (responseData.success) {
      commit('updateCompUserDDList', responseData.data)
    } else {
      commit('updateCompUserDDList', [])
    }
  },
  async findSysAuth({
    commit,
    state
  }, { codeParam }) {
    state.authedFnKeyMap = {}
    const responseData = await getReq(END_POINTS.FIND_SYS_AUTH + ``, { headerCodeMap: await getHeaderCodeMap(codeParam) })
    if (responseData.success) {
      // updateAuthedKey(state, responseData.data)
      await commit('updateAuthedKeyList', responseData.data)
    } else {
      await commit('updateAuthedKeyList', [])
    }
    // debugger
  },
  async findCompAuth({
    commit,
    state
  }, { compId, codeParam }) {
    state.authedFnKeyMap = {}
    const responseData = await getReq(END_POINTS.FIND_COMP_AUTH + `?compId=${compId}`, { headerCodeMap: await getHeaderCodeMap(codeParam) })
    if (responseData.success) {
      // updateAuthedKey(state, responseData.data)
      await commit('updateAuthedKeyList', responseData.data)
    } else {
      await commit('updateAuthedKeyList', [])
    }
  },
  async findProjAuth({
    commit,
    state
  }, { compId, projId, codeParam }) {
    state.authedFnKeyMap = {}
    const responseData = await getReq(END_POINTS.FIND_PROJ_AUTH + `?compId=${compId}&projId=${projId}`, { headerCodeMap: await getHeaderCodeMap(codeParam) })
    if (responseData.success) {
      // updateAuthedKey(state, responseData.data)
      await commit('updateAuthedKeyList', responseData.data)
    } else {
      await commit('updateAuthedKeyList', [])
    }
  }
}

const mutations = {
  updateCompUserDDList(state, list) {
    // state.ctrAcctDDList = value
    state.compUserDDList = Utils.toListWapper(list, {valueField: 'userId', descrField: ['familyName', 'firstName']})
  },
  refreshCurrentMenuSider(state) {
    if (!state.currentSubsysKey || !state.SYSTEM_SIDER[state.currentSubsysKey]) {
      state.currentMenuSider = []
      return
    }

    // ...
    const subsys = JSON.parse(JSON.stringify(state.SYSTEM_SIDER[state.currentSubsysKey])) // { ...state.SYSTEM_SIDER.PROJ }
    subsys.children.forEach(moduleTypeObj => {
      moduleTypeObj.children = moduleTypeObj.children.filter(moduleObj => {
        let routeMatched = router.match(moduleObj.path).matched
        if (!Lodash.isEmpty(routeMatched) && routeMatched.length > 0 && routeMatched[1].props) {
          let props = routeMatched[1].props.default || {}
          let moduleCode = props.moduleCode
          return moduleCode && state.authedModuleKeyList.indexOf(moduleCode) >= 0
        }

        return false
      })
    })

    // subsys.children = subsys.children.filter(moduleTypeObj => {
    //   return moduleTypeObj.children && moduleTypeObj.children.length > 0
    // })
    state.currentMenuSider = subsys
  },
  async updateAuthedKeyList(state, authedKeyCollection) {
    state.authedSubsysKeyList = authedKeyCollection.subsysKeyList
    state.authedModuleKeyList = authedKeyCollection.moduleKeyList
    state.authedFnKeyList = authedKeyCollection.fnKeyList
    const map = {}
    state.authedFnKeyList.forEach(item => {
      map[item] = true
    })
    state.authedFnKeyMap = map

    // 这里只是为控制公司成员访问系统、公司数据板块，所以每个公司成员都能访问 subsysType==BIZ 类型的板块（项目版、公司版）
    // TODO POWER: 需要考虑如何解决在公司层级的页面（接口）就知道用户在该公司的项目（业务）权限，如此才能知道用户可以访问哪些业务板块
    state.currentSubsysList = Lodash.filter(state.subsysDDList, item => {
      return state.authedSubsysKeyList.indexOf(item.subsysKey) > -1
    })
    await this.commit('systemAuthManage/refreshCurrentMenuSider')
  },
  updateCurrentSubsysKey(state, value) {
    state.currentSubsysKey = value
  },
  updateCurrentModuleType(state, value) {
    state.currentModuleType = value
  },
  cleanAll(state) {
    state.currentMenuSider = []
    state.authedSubsysKeyList = []
    state.authedModuleKeyList = []
    state.authedFnKeyList = []
    state.authedFnKeyMap = {}
    state.currentSubsysKey = ''
    state.currentSubsysList = []
    state.currentModuleType = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/systemAuthManage.js